import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../shared/services/storage.service';
import { AlertsService } from '../../../services/alerts.service';

@Component({
    selector: 'kx-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  public _resourceDef: any;
  public _currentResource: string = '';
  formBlocks: any = [];
  activatedResource: string;
  showflatform: boolean = false;
  objData: { formblocks: any; data: any; activatedResource: string; };
  currentFields: any = {};
  id: any;
  action: string;
  editButton: string = "Edit Profile";
  showEditBtn: boolean = true;
  userData: any;
  newUserData: any = {
    designation: "Doctor",
    department_id: "department1",
    subDepartment_id: "Oncology",
    registration_no: "UIDS4362",
    speciality_id: "physiatrist",
    joining_date: "12/12/2019",
    reliving_date: "14/12/2019",
    signature: "yes",
    signature_footer: "footer",
    name: "Axhar",
    telecom: "22716627",
    emailid: "kx@kx.com",
    doctor_code: "DOC3624",
    display_name: "HELLO",
    birthDate: "10/03/1996",
    gender_id: "male",
    gender_name: "MALE",
    marital_id: "A",
    marital_name: "Married",
    blood_group_id: "278149003",
    blood_group_name: "Blood group A Rh(D) positive",
    language_id: "hi",
    language_name: "Hindi",
    identityType: "passport",
    identityNumber: "ID7769",
    patientType: "op",
    institute: "PIET",
    qualification: "MBBS",
    countryId: "India",
    state: "delhi",
    given: "middle name",
    family: "ewoo",
    text: "first name",
    address: {
      text: "12",
      city: "delhi",
      district: "delhi",
      state: "delhi",
      postalCode: "110096"
    },
    name_: {
      text: "pqr",
      family: "xyz",
      given: "",
      prefix: "mr"
    }
  }
  config: any;
  constructor(private baseService: BaseService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private alertService: AlertsService) {
    this.action = 'VIEW';
  }

  ngOnInit() {
    this.config = {
      "submitButton" : true,
      "cancelButton" : true,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.activatedResource = this.route.snapshot.data.resource;
    this.getResource();
    this.getUserData();
  }

  getResource() {
    this.baseService.init(this._currentResource);
    this.baseService.getResourceDef(this._currentResource, (resourceDef) => {
      if (resourceDef) {
        this._resourceDef = resourceDef;
        this.formBlocks = resourceDef.form
        this.baseService.getReferredField(resourceDef.form, (response) => {
          this.currentFields.blocks = response;
        });
      }
    })
  }

  setForm() {
    this.objData = { formblocks: this.formBlocks, data: null, activatedResource: this.activatedResource };
    this.activatedResource = this.activatedResource;
    this.showflatform = true;
  }

  onSaveFinished(event) {
    this.baseService.action(event.result, 'MODIFY', '', this._currentResource).subscribe((res) => {
      if (res.errCode == -1) {
        this.alertService.error(res.message);
      } else {
        this.alertService.success('Profile Updated Successfully');
      }
    })
  }

  getUserData() {
    this.storageService.getData('currentUser', (userId) => {
      this.id = userId.id
    })
    // This code commented by Sanjay : it's hard code vlaue use in the code.
    // this.baseService.getById("500cfb90-4d97-11ea-9313-524741ad229d-29", "patient", "patient-registration").subscribe(res => {
    //   console.log('id response is', res);
    //   if (res) {
    //     this.userData = this.newUserData;
    //   }
    //   this._currentResource = 'practitioner_facility_details_doctor';
    //   this.getResource();
    // })
  }
  
  changeAction() {
    this.action = 'MODIFY';
    this.showEditBtn = false;
  }
}
